import React from 'react'
import styles from './LPHeader.module.scss'
import { useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

interface HeaderLink {
  href: string
  title: string
}

const headerLinks: HeaderLink[] = [
  {
    href: '/services/',
    title: 'SERVICES',
  },
  {
    href: '/cases',
    title: 'CASE',
  },
  {
    href: '/about/',
    title: 'ABOUT',
  },
  {
    href: '/topics/all/page/1',
    title: 'TOPICS',
  },
  {
    href: '/recruit/',
    title: 'RECRUIT',
  },
]

const LPHeader: React.FC = () => {
  const spNav = useRef<HTMLDivElement>()
  const pcNav = useRef<HTMLDivElement>()
  const nav = useRef<HTMLElement>()
  useEffect(() => {
    gsap.to(spNav.current, {
      borderRadius: '80px',
      duration: 0.5,
      margin: '16px 0',
      scale: '0.93',
      scrollTrigger: {
        trigger: 'body',
        start: 'top -10px',
        end: 'top -10px',
        toggleActions: 'play none none reverse',
      },
    })

    gsap.to(pcNav.current, {
      webkitFilter: 'drop-shadow(4px 4px 6px rgba(0, 0, 0, 0.06))',
      scrollTrigger: {
        trigger: pcNav.current,
        start: 'top+=10px top',
        scrub: true,
      },
    })
  }, [])

  const headerList = headerLinks.map(({ href, title }) => (
    <li key={title} className={`${styles.li} ${styles.SP_none}`}>
      <a rel="noopener" target="_blank" href={href}>
        {title}
      </a>
    </li>
  ))

  return (
    <header>
      <div className={styles.pc}>
        <nav className={styles.nav} ref={pcNav}>
          <li className={styles.i3_img_li}>
            <a rel="noopener" target="_blank" href="/">
              <img className={styles.i3_img} src="/img/common/logo_aitria.svg" alt="Aitria" />
            </a>
          </li>
          {headerList}
          <li className={`${styles.li} ${styles.SP_none}`}>
            <a href="#contact">CONTACT</a>
          </li>
        </nav>
      </div>
      <div className={styles.sp}>
        <nav className={styles.nav} ref={spNav}>
          <li className={styles.i3_img_li}>
            <a rel="noopener" target="_blank" href="/">
              <img className={styles.i3_img} src="/img/common/logo_aitria.svg" alt="Aitria" />
            </a>
          </li>
          <li className={`${styles.li} ${styles.PC_none}`}>
            <a className={styles.contact} href="#contact">
              お問い合わせ
            </a>
            <span className={styles.mailIcon}></span>
          </li>
        </nav>
      </div>
    </header>
  )
}

export default LPHeader
